namespace GeniuzPOS.InitialData {
    export interface PsDebitCardForm {
        DebitCardType: Serenity.StringEditor;
        IsActive: Serenity.BooleanEditor;
        DebitCardName: Serenity.StringEditor;
        ProdImageLink: Serenity.ImageUploadEditor;
    }

    export class PsDebitCardForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDebitCard';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDebitCardForm.init)  {
                PsDebitCardForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.ImageUploadEditor;

                Q.initFormType(PsDebitCardForm, [
                    'DebitCardType', w0,
                    'IsActive', w1,
                    'DebitCardName', w0,
                    'ProdImageLink', w2
                ]);
            }
        }
    }
}
